import { useTranslation } from "react-i18next";
import AssetManager from "../../../../common/AssetManager";
import { ClothesLayer } from "../../../../context/suggestionContext/suggestionTypes";

const LayersComponent: React.FC<LayersComponentProps> = ({
  clothesForLayers,
  selectedLayer,
  onLayerSelectionChanged,
  activeLayers,
}) => {
  const { i18n } = useTranslation();

  return (
    <div className="layers-container">
      {clothesForLayers?.map((layer, index) => (
        <div className="layer-row" key={index}>
          <div
            className={`layer-button ${
              selectedLayer == index ? "layer-button-selected" : ""
            }`}
            onClick={() => {
              onLayerSelectionChanged(index);
            }}
          >
            <span className="layer-button-label">{index + 1}</span>
          </div>

          <img
            src={AssetManager.getAsset(
              layer.clothes[activeLayers[index]]?.availablePalettes[0].imageUrl
            )}
            alt="layer-image"
            className="layer-image"
          />
        </div>
      ))}
    </div>
  );
};

export default LayersComponent;

interface LayersComponentProps {
  clothesForLayers: ClothesLayer[];
  selectedLayer: number;
  activeLayers: number[];
  onLayerSelectionChanged: (index: number) => void;
}
